import { supabase } from '../utils/supabase';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

async function headers(): Promise<Record<string, string>> {
  const { data: { session } } = await supabase.auth.getSession();
  return { 'Content-Type': 'application/json', ...(session?.access_token ? { Authorization: `Bearer ${session.access_token}` } : {}) };
}

async function call(path: string, method: 'POST' | 'PATCH', body: unknown) {
  const res = await fetch(`${API_URL}/chat/feedback-bot${path}`, { method, headers: await headers(), body: JSON.stringify(body) });
  if (!res.ok) throw Object.assign(new Error(`feedback-bot ${res.status}`), { status: res.status });
  return (await res.json()).episode as { id: string; outcome: string };
}

export const createEpisode = (messageId: string, trigger: 'auto' | 'manual') =>
  call('/episodes', 'POST', { message_id: messageId, trigger });
export const updateEpisode = (id: string, patch: Record<string, unknown>) =>
  call(`/episodes/${id}`, 'PATCH', patch);
